export default function VendorResourcesController(
  $q,
  $rootScope,
  $scope,
  alerts,
  bcpSharedModelService,
  confirmDialog,
  loaderService,
  selectVendorResourcesDialog,
  serviceIds,
  ssDialogService,
  userService,
  vmSharedModelService,
) {
  const vm = this;

  vm.canExpand = true;
  vm.hasData = false;
  vm.serviceId = serviceIds.BCP;
  vm.handleExpand = _handleExpand;
  vm.handleSelect = _handleSelect;
  vm.loadResources = _loadVendorResources; // for import

  _activate();

  /** **************************************************
   * Event Handlers
   */

  function _handleExpand() {
    if (!vm.hasData) {
      return _loadVendorResources();
    }
    return Promise.resolve();
  }

  function _handleSelect($event) {
    vmSharedModelService.clearFilters();
    const que = [vmSharedModelService.getVendors(vm.serviceId, true)];
    if (!vm.hasData) {
      que.push(bcpSharedModelService.getVendorResources(vm.assessmentId, true));
    }
    loaderService.showViewLoader = true;
    return $q.all(que).then((results) => {
      loaderService.showViewLoader = false;
      const vendors = bcpSharedModelService.sortByName(results[0]);
      if (!vm.hasData) {
        vm.vendorResources = results[1];
        vm.hasData = true;
      }
      return _showSelectDialog($event, {
        vendors,
        assessmentId: vm.assessmentId,
        vendorResources: vm.vendorResources,
      });
    });
  }

  /** **************************************************
   * Private Functions
   */

  function _activate() {
    $scope.$on('loadVendorResources', _loadVendorResources);
    loaderService.showViewLoader = true;
    $q.all([
      userService.getUserPermissionSet('bcp'),
      userService.getUser(),
    ]).then((results) => {
      loaderService.showViewLoader = false;
      vm.permissions = results[0];
      vm.customerId = results[1].customerId;
    });
  }

  function _loadVendorResources() {
    loaderService.showViewLoader = true;
    return bcpSharedModelService.getVendorResources(vm.assessmentId, true)
      .then((vendorResources) => {
        loaderService.showViewLoader = false;
        vm.vendorResources = vendorResources;
        vm.hasData = true;
        $rootScope.$broadcast('refreshStatuses');
      });
  }

  function _showSelectDialog($event, locals) {
    ssDialogService.dialogs.bcp.selectVendorResourcesDialog = ssDialogService.alert(
      selectVendorResourcesDialog.getOptions($event, locals)
    );
    return ssDialogService.show(ssDialogService.dialogs.bcp.selectVendorResourcesDialog);
  }
}

VendorResourcesController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'bcpSharedModelService',
  'confirmDialog',
  'loaderService',
  'selectVendorResourcesDialog',
  'serviceIds',
  'ssDialogService',
  'userService',
  'vmSharedModelService',
];
